// extracted by mini-css-extract-plugin
export var text = "_30-0";